const mapLayers = {
  options: {
    layers: 'Layers',
    ev: 'EV',
    bookings: 'Bookings',
    heatMap: 'Heat Map',
  },
  legend: {
    powerType: {
      slow: 'Slow',
      fast: 'Fast',
      turbo: 'Turbo',
    },

    availability: {
      available: 'Available',
      notAvailable: 'Unavailable',
      selected: 'Selected',
      broken: 'Broken',
      unknown: 'Unknown',
    },
  },
};

export default mapLayers;
